import * as React from 'react';
import { ISearchResultHitDTO, ISearchResultDTO, ResultTypeEnum } from '../../DTO/search';
import { IContentProps } from '../../models/content-props';

interface IProps {
    result: ISearchResultHitDTO;
    content: IContentProps;
    showUrl: boolean;
    onClick: (hitId) => void;
}

export class Result extends React.Component<IProps, any> {
    render() {
        var { result, onClick } = this.props;

        switch (result.searchResultType) {
            case ResultTypeEnum.School:
                return this.renderSchool();
            case ResultTypeEnum.Default:
            default:
                return this.renderDefault();
        }
    }

    renderDefault = () => {
        var { result, onClick } = this.props;
        const hitOnClick = () => onClick(result.hitId);
        return (
            <li className={"directory-list-item rich-text" + (result.isBestBet ? " best-bet" : "")}>
                <div className={result.categories && 'has-preheading'}>
                    <h3 className="h4-style">
                       
                        <a href={result.url} onClick={hitOnClick} dangerouslySetInnerHTML={{ __html: result.title }}></a>
                    </h3>
                    {result.categories ?
                        result.categories.map((x, index) => this.renderCategory(x, index))
                        : null}
                </div>

                {result.description ?
                    <div className="rich-text directory-result-description" dangerouslySetInnerHTML={{ __html: this.renderDescription(result.description) }} />
                    : null
                }
                {
                    result.url && this.props.showUrl &&
                    <p>
                        <a className="small regular visible-url" href={result.url} onClick={hitOnClick}
                            dangerouslySetInnerHTML={{ __html: this.renderUrlText(result.url) }} />
                    </p>
                }
            </li>
        )
    }

    renderSchool = () => {
        var { result, onClick, content } = this.props;
        const hitOnClick = () => onClick(result.hitId);
        const mapLink = `${content.mapLinkUrl}${result.id.toString()}`;
        return (
            <li className={"directory-list-item" + (result.isBestBet ? " best-bet" : "")}>
                <div className={result.categories && 'has-preheading'}>
                    <h3 className="h4-style">
                        <a href={result.url} onClick={hitOnClick} dangerouslySetInnerHTML={{ __html: result.title }}></a>
                    </h3>
                    {result.categories ?
                        result.categories.map((x, index) => this.renderCategory(x, index))
                        : null}
                </div>

                <div className="rich-text directory-result-description directory-result-description-clamp" dangerouslySetInnerHTML={{ __html: this.renderDescription(result.description, true) }} />
                <div className="directory-numbers">
                    {!content.hidePhoneNumber &&
                        result.phoneNumber &&
                        !! result.phoneNumber.trim().length &&
                        <p className="directory-numbers-item"><a href="tel:{result.phoneNumber}">{result.phoneNumber}</a></p>
                    }
                    {
                        !content.hideAddress &&
                        result.address && result.id &&
                        <p className="directory-numbers-item"><a href={mapLink}>
                            {!content.hideMapLink &&
                                <svg className="svg-icon" aria-hidden="true" focusable="false">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-map-marker" />
                                </svg>
                            }
                            <span>{result.address}</span>
                        </a></p>
                    }
                    {
                        !content.hideGradesOffered &&
                        result.gradesOffered &&
                        <p className="directory-numbers-item bold"><span className="visually-hidden">{content.gradesOfferedLabel}: </span>{result.gradesOffered.split(',').join(', ')}</p>
                    }
                </div>
                <div className="directory-tags">
                    <ul className="directory-tag-list">
                        {
                            !content.hideRating &&
                            result.rating &&
                            <li className="directory-tag-list-item">{content.ratingLabel}: {result.rating}</li>
                        }
                        {
                            !content.hideStudentCount &&
                            <li className="directory-tag-list-item">{content.studentCountLabel && content.studentCountLabel.length > 0 && `${content.studentCountLabel}: `}{result.studentCount}</li>
                        }
                        {
                            !content.hideCampusAccessibility && result.campusAccessibility &&
                            <li className="directory-tag-list-item">{content.campusAccessibilityLabel && content.campusAccessibilityLabel.length > 0 && `${content.campusAccessibilityLabel}: `}{result.campusAccessibility}</li>
                        }
                        {
                            !content.hideParkingAccessibility && result.parkingAccessibility &&
                            <li className="directory-tag-list-item">{content.parkingAccessibilityLabel && content.parkingAccessibilityLabel.length > 0 && `${content.parkingAccessibilityLabel}: `}{result.parkingAccessibility}</li>
                        }
                        {
                            !content.hideGovernance &&
                            result.governance &&
                            <li className="directory-tag-list-item">{content.governanceLabel}: {result.governance}</li>
                        }
                        {
                            !content.hideNetwork &&
                            result.network &&
                            <li className="directory-tag-list-item">{content.networkLabel && content.networkLabel.length > 0 && `${content.networkLabel}: `}{result.network}</li>
                        }
                        {
                            !content.hideProgramTypes &&
                            result.programTypes && result.programTypes.length > 0 &&
                            <li className="directory-tag-list-item">{content.programTypesLabel}: {result.programTypes.join(", ")}</li>
                        }
                        {
                            !content.hidePrograms &&
                            result.programs && result.programs.length > 0 &&
                            <li className="directory-tag-list-item">{content.programsLabel}: {result.programs.join(", ")}</li>
                        }
                        {
                            !content.hideDressCode &&
                            result.hasDressCode &&
                            <li className="directory-tag-list-item">{content.hasDressCodeLabel}</li>
                        }
                        {
                            !content.hideGoCPS &&
                            result.isGoCPSParticipant &&
                            <li className="directory-tag-list-item">
                                <span className="visually-hidden">{content.isGoCPSLabel}</span>
                                <svg className="svg-icon svg-icon-lg" aria-hidden="true" focusable="false">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#logo-gocps" />
                                </svg>
                            </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }

    renderCategory(category: string, index: number) {
        return (<p key={category + '-' + index} className="h6-style preheading">{category}</p>);
    }

    renderDescription(description: string, shorten?: boolean) {
        if (!description) return "";
        // remove all inline styles
        let formatted = description.replace(/ *style ?= ?".*"/ig, '');

        // remove all links from description
        const parser = new DOMParser();
        const links = parser.parseFromString(description, 'text/html').getElementsByTagName('a');
        if (links && links.length > 0) {
            for (let i = 0; i < links.length; i++) {
                formatted = formatted.replace(links[i].outerHTML, links[i].innerHTML)
            }
        }

        // remove empty spans/paragraphs in some schools
        formatted = formatted.replace(/&nbsp;/g, ' ');
        formatted = formatted.replace(/<span *> *<\/span>/g, '');
        formatted = formatted.replace(/<p *> *<\/p>/g, '').trim();
        // shorten with ellipsis 
        if (shorten && formatted.length > 150) {
            formatted = formatted.substr(0, 150);
            formatted = formatted.substr(0, formatted.lastIndexOf(' '));
            formatted = `${formatted}...`;
        }
        // add <p> if it doesn't have one at the beginning, add </p> if it doesn't have one at the end
        formatted = /^<p>/i.test(formatted) ? formatted : `<p>${formatted}`;
        formatted = /<\/p>$/i.test(formatted) ? formatted : `${formatted}</p>`;
        return formatted;
    }

    renderUrlText(url: string) {
        return url.replace(/^\/\/|^.*?:(\/\/)?/, '').replace(/\//g, '/&shy;');
    }
}